<template>
  <div class="order" id="tab">
    <el-tabs v-model="activeName" type="border-card" class="tabs" @tab-click="handleClick">
      <el-tab-pane name="commodity" label="商品汇总"></el-tab-pane>
      <el-tab-pane name="customer" label="客户汇总"></el-tab-pane>
      <el-tab-pane name="business" label="业务汇总"></el-tab-pane>
      <el-tab-pane name="deliverUser" label="配送员汇总"></el-tab-pane>
      <el-tab-pane name="completionRate" label="完成率"></el-tab-pane>
    </el-tabs>
    <div class="main el-tabs el-tabs--top el-tabs--border-card">
      <section class="el-tabs__content el-container">
        <aside class="el-aside" :style="{ width: isCollapse ? '20px' : '230px' }" v-if="activeName != 'completionRate'">
          <el-card v-show="!isCollapse" class="aside-card">
            <div slot="header">
              <span>查询条件</span>
              <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text"
                @click="isCollapse = !isCollapse"></el-button>
            </div>
            <el-form ref="queryFormRef" :model="queryForm" size="small">
              <el-scrollbar>
                <el-form-item label="日期" prop="billDate.selected">
                  <date-picker class="query_form_item" style="width: 100%;" v-model="queryForm.billDate.selected"
                    type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                  </date-picker>
                </el-form-item>
                <el-form-item label="订单状态" prop="billStatus.selected">
                  <el-select v-model="queryForm.billStatus.selected" multiple value-key="value" placeholder="请选择订单状态">
                    <el-option v-for="item in queryForm.billStatus.list" :key="item.value" :label="item.text"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="业务员" prop="salesman.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.salesman"></select-multiple>
                </el-form-item>
                <el-form-item label="配送员" prop="deliverUser.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.deliverUser"></select-multiple>
                </el-form-item>
                <el-form-item label="是否有余货" prop="isHaveResidual.selected">
                  <el-select v-model="queryForm.isHaveResidual.selected" clearable placeholder="请选择是否有余货">
                    <el-option v-for="item in queryForm.isHaveResidual.list" :key="item.value" :label="item.text"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户大片区" prop="domainDesc.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.domainDesc"></select-multiple>
                </el-form-item>
                <el-form-item label="客户小片区" prop="smallDomain.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.smallDomain"></select-multiple>
                </el-form-item>
                <el-form-item label="客户类型" prop="customerTypes.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.customerTypes"></select-multiple>
                </el-form-item>
                <el-form-item label="客户" prop="customer.selected">
                  <el-select class="select_multiple query_form_item" ref="customerSelectRef"
                    v-model="queryForm.customer.selected" value-key="value" multiple clearable placeholder="请选择客户名称"
                    @click.native="customerInputFocus">
                    <el-option v-for="item in queryForm.customer.list" :key="item.value" :label="item.text"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户标签" prop="label.selected">
                  <el-select v-model="queryForm.label.selected" filterable multiple value-key="id" placeholder="请选择客户标签">
                    <el-option v-for="item in queryForm.label.list" :key="item.id" :label="item.labelDesc" :value="item">
                      <span>{{ item.labelDesc }}({{ item.shortName }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="仓库" prop="inWarehouse.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.inWarehouse"></select-multiple>
                </el-form-item>
                <el-form-item label="品牌" prop="financialBrand.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.financialBrand"
                    :isClear="false"></select-multiple>
                </el-form-item>
                <el-form-item label="大类" prop="brand.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.brand"
                    :change="brandChange"></select-multiple>
                </el-form-item>
                <el-form-item label="小类" prop="brandType.selected">
                  <select-multiple class="query_form_item" :select-data="queryForm.brandType"></select-multiple>
                </el-form-item>
                <el-form-item label="商品" prop="product.selected">
                  <el-select class="select_multiple query_form_item" ref="productSelectRef"
                    v-model="queryForm.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称"
                    @click.native="productInputFocus">
                    <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text"
                      :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-scrollbar>
              <el-form-item style="text-align: center;">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
            <span style="text-align: center;">查询</span>
            <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
            <span style="text-align: center;">条件</span>
          </div>
        </aside>
        <main class="el-main" v-loading="tableLoading">
          <el-card shadow="never" v-if="activeName != 'completionRate'">
            <el-form :inline="true">
              <el-form-item size="mini">
                <el-button type="success" @click="tableExport">导出</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-if="activeName != 'completionRate'">
            <commodity ref="table" v-if="activeName == 'commodity'" :table-data="tableData" :table-sum="tableSum"
              @sort-change="sortChange" @expand-detail="getTableDetailList" @draw-detail="tableDBClick"></commodity>
            <customer ref="table" v-if="activeName == 'customer'" :table-data="tableData" :table-sum="tableSum"
              @sort-change="sortChange" @expand-detail="getTableDetailList" @draw-detail="tableDBClick"></customer>
            <business ref="table" v-if="activeName == 'business'" :table-data="tableData" :table-sum="tableSum"
              @sort-change="sortChange" @expand-detail="getTableDetailList" @draw-detail="tableDBClick"></business>
            <deliverUser ref="table" v-if="activeName == 'deliverUser'" :table-data="tableData" :table-sum="tableSum"
              @sort-change="sortChange" @expand-detail="getTableDetailList" @draw-detail="tableDBClick"></deliverUser>
          </div>
          <el-pagination v-if="activeName != 'completionRate'" background class="pagination"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page"
            :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"></el-pagination>
          <completionRate v-if="activeName == 'completionRate'"></completionRate>
        </main>
      </section>
    </div>
    <el-drawer :visible.sync="detailDrawer" direction="rtl" :with-header="false" destroy-on-close size="70%"
      custom-class="detail_drawer">
      <template>
        <el-card shadow="never" class="detail_drawer_card" ref="drawerTableCard">
          <el-row type="flex" style="flex-wrap: wrap;">
            <el-col :span="8"><label>单号:</label><span>{{ arguments.billType == 'C' ? detailDrawerHeader.exchangeBillNo :
              detailDrawerHeader.billNo }}</span></el-col>
            <el-col :span="8" v-if="arguments.billType != 'T'"><label>装车单号:</label><span>{{ detailDrawerHeader.loadBillNo
            }}</span></el-col>
            <el-col :span="8"><label>制单日期:</label><span>{{ detailDrawerHeader.entryDate }}</span></el-col>
            <el-col :span="8"
              v-if="arguments.orderState == 'delivery' && arguments.billType != 'T'"><label>装车日期:</label><span>{{
                detailDrawerHeader.loadDate }}</span></el-col>
            <el-col :span="8"
              v-if="arguments.orderState == 'accomplish' && arguments.billType != 'T'"><label>发货日期:</label><span>{{
                detailDrawerHeader.deliverDate }}</span></el-col>
            <el-col :span="8"><label>客户:</label><span>{{ detailDrawerHeader.customerName }}</span></el-col>
            <el-col :span="8"><label>配送员:</label><span>{{ detailDrawerHeader.deliverUserName }}</span></el-col>
            <el-col :span="8"><label>配送车辆:</label><span>{{ detailDrawerHeader.vehicleName }}</span></el-col>
            <el-col :span="8" v-if="arguments.billType != 'T'"><label>出库仓库:</label><span>{{
              detailDrawerHeader.warehouseName }}</span></el-col>
            <el-col :span="8"><label>业务员:</label><span>{{ detailDrawerHeader.salesmanName }}</span></el-col>
            <el-col :span="8"><label>商品数量:</label><span>{{ detailDrawerHeader.billQtyStr }}</span></el-col>
            <el-col :span="8"
              v-if="arguments.billType == 'A'"><label>付款类型:</label><span>{{ detailDrawerHeader.payType }}</span></el-col>
            <el-col :span="8"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
            <el-col :span="8"><label>操作:</label><el-button size="mini" type="primary"
                @click="detailExport">导出</el-button></el-col>
            <el-col :span="8"><label>状态:</label><el-tag>{{ detailDrawerHeader.orderStatus }}</el-tag></el-col>
          </el-row>
        </el-card>
        <div class="drawerTable" ref="drawerTableList">
          <el-table ref="drawerTable" v-loading="drawerTableIsLoading" :data="detailList" border size="mini" stripe
            height="100%" max-height="100%">
            <el-table-column label="商品名称" prop="itemName" width="180">
              <template slot-scope="{ row }">
                <span>{{ row.itemName }}</span>
                <el-tag key="isDiffPrice" v-show="row.isDiffPrice == 'Y'"
                  style="color: rgba(0, 206, 209, 1); background-color: rgba(0, 206, 209, 0.1)" size="mini">变</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="itemSpec"></el-table-column>
            <el-table-column label="销售形式" prop="isLargessFormat"></el-table-column>
            <el-table-column label="订单数量" prop="billQtyStr"></el-table-column>
            <el-table-column label="小单位数量" prop="invQty" width="90"></el-table-column>
            <el-table-column label="配送数量" prop="consignQtyStr"></el-table-column>
            <el-table-column
              v-if="['all', 'accomplish'].includes(arguments.orderState) && ['A', 'B'].includes(arguments.billType)"
              label="差量" prop="diffCount"></el-table-column>
            <el-table-column label="单价" v-if="arguments.billType != 'C'" prop="billPriceStr"></el-table-column>
            <el-table-column label="生产日期" prop="productionDate"></el-table-column>
            <el-table-column label="条码" prop="barCode" width="140">
              <template slot-scope="scope">
                <div v-if="scope.row.salBarCode">
                  <span>{{ scope.row.salBarCode }}</span><span>/大</span>
                </div>
                <div v-if="scope.row.midBarCode">
                  <span>{{ scope.row.midBarCode }}</span><span>/中</span>
                </div>
                <div v-if="scope.row.invBarCode">
                  <span>{{ scope.row.invBarCode }}</span><span>/小</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="总价" v-if="arguments.billType != 'C'" prop="totalAmt"></el-table-column>
            <el-table-column label="口味名称" prop="flavorDesc"></el-table-column>
            <el-table-column label="口味对应条码" prop="flavorBarCode" width="120"></el-table-column>
            <el-table-column label="备注" prop="remark"></el-table-column>
          </el-table>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import commodity from '@/components/saleManage/orderReport/commodity.vue'
import customer from '@/components/saleManage/orderReport/customer.vue'
import business from '@/components/saleManage/orderReport/business.vue'
import deliverUser from '@/components/saleManage/orderReport/deliverUser.vue'
import completionRate from '@/components/saleManage/orderReport/completionRate.vue'
import { pickerOptions, toRawType, getAddDate, getNowFormatDate, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: "OrderReport",
  components: {
    datePicker,
    commodity,
    customer,
    business,
    deliverUser,
    completionRate
  },
  data() {
    let beginDate = getAddDate(-3)
    let endDate = getNowFormatDate()
    let billStatusList = [
      { value: 'A', text: '待调度', type: 'warning' },
      { value: 'C', text: '待配送', type: 'success' },
      { value: 'D', text: '已发货', type: 'danger' },
      { value: 'E', text: '已作废', type: 'info' }
    ]
    let isHaveResidualList = [
      { value: '1', text: '没有余货' },
      { value: '2', text: '有余货' }
    ]
    return {
      isCollapse: false,
      queryForm: {
        isContainBack: { submitName: 'isContainBack', selected: 'N' },
        label: { submitName: 'label', selected: [], list: [] },
        isHaveResidual: { submitName: 'isHaveResidual', selected: '', list: isHaveResidualList },
        billStatus: { submitName: 'billStatus', selected: [...billStatusList.filter(i => i.value != 'E')], list: [...billStatusList] },
        billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
        domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户大片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        smallDomain: { submitName: 'smallDomainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户小片区', request: { url: '/Account/domainDefine/getSmallDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类型', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
        inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        financialBrand: { submitName: 'itemBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: true, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: { page: 1, size: 5, isPage: 'Y' }, text: '', value: '' } },
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        salesman: { submitName: 'salesmanID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
        deliverUser: { submitName: 'deliverUserID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择配送员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
      },
      pickerOptions: pickerOptions,
      activeName: 'commodity',
      pagination: {
        page: 1,
        size: 20,
        sortField: '',
        sortBy: '',
        total: 0
      },
      tableLoading: false,
      tableData: [],
      tableSum: {},
      detailDrawer: false,
      detailDrawerHeader: {},
      detailList: [],
      drawerTableIsLoading: false,
      detailDrawerActiveRow: {}
    }
  },
  created() {
    this.getLabelData()
    this.onSubmit()
  },
  mounted() {
    window.top.addEventListener('message', this.messageOfSelect)
  },
  beforeDestroy() {
    window.top.removeEventListener('message', this.messageOfSelect)
  },
  methods: {
    async getLabelData() {
      const { data: res } = await this.$http.post('/Account/pubLabelDefineVue/selectLabelList.html', this.Qs.stringify({ labelType: '001' }))
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      this.queryForm.label.list = JSON.parse(res.result.data)
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.queryForm.brandType.request.params['brandID'] = str
      this.queryForm.brandType.isReSearch = true
    },
    customerInputFocus() {
      this.$refs['customerSelectRef'].blur()
      window.top.openDialog55('选择客户', '/Account/sys/common/customerSelect.html?isFitterEnabled=N&tag=OrderReportCustomer')
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      window.top.openDialog55('选择商品', '/Account/sys/common/productSelect.html?tag=OrderReportProduct&isFitterEnabled=N')
    },
    // 接受子页面数据
    messageOfSelect(e) {
      let { data: res } = e
      if (res.tag == 'OrderReportProduct') {
        if (res.code != 'success') return false
        this.$set(this.queryForm.product, 'list', res.data)
        this.queryForm.product.selected = res.data
        top.layer.closeAll('iframe')
      } else if (res.tag == 'OrderReportCustomer') {
        if (res.code != 'success') return false
        this.$set(this.queryForm.customer, 'list', res.data)
        this.queryForm.customer.selected = res.data
        top.layer.closeAll('iframe')
      }
    },
    onSubmit() {
      let tempItem = {}
      this.tableData = []
      this.tableSum = {}
      this.pagination.page = 1
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') {
            tempItem['beginDate'] = item.selected[0] || ''
            tempItem['endDate'] = item.selected[1] || ''
            return false
          }
          if (item.submitName == 'label') {
            tempItem[item.submitName] = item.selected.map(i => "'" + i.id + "'").join(',') || ''
            return false
          }
          tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'String') {
          tempItem[item.submitName] = item.selected || ''
        } else if (toRawType(item.selected) == 'Number') {
          tempItem[item.submitName] = item.selected || 0
        } else if (toRawType(item.selected) == 'Object') {
          tempItem[item.submitName] = item.selected.value || ''
        }
      })
      this.queryFormat = tempItem
      this.$nextTick(() => {
        this.getTable()
      })
    },
    async getTable() {
      // this.tableLoading = true
      let url = ''
      if (this.activeName == 'commodity') {
        url = '/erpnew/account/c/reada46ceb/salOrderReport/selectItemCollectList.html'
      } else if (this.activeName == 'customer') {
        url = '/erpnew/account/c/reada46ceb/salOrderReport/selectCustomerCollectList.html'
      } else if (this.activeName == 'business') {
        url = '/erpnew/account/c/reada46ceb/salOrderReport/selectSalesmanCollectList.html'
      } else if (this.activeName == 'deliverUser') {
        url = '/erpnew/account/c/reada46ceb/salOrderReport/selectDeliverUserCollectList.html'
      }
      const { data: res } = await this.$post(url, { ...this.queryFormat, ...this.pagination })
      this.tableLoading = false
      if (res.code == 0) {
        this.tableData = res.data.data
        this.tableSum = res.data.sum
        this.pagination.total = res.data.total
      } else {
        this.$alert(res.message, '提示')
      }
    },
    async getTableDetailList(row) {
      if (!row.isLoad) {
        let params = { ...this.queryFormat, ...this.pagination }
        if (this.activeName == 'commodity') {
          params.itemID = "'" + row.itemID + "'"
        } else if (this.activeName == 'customer') {
          params.customerID = "'" + row.customerID + "'"
        } else if (this.activeName == 'business') {
          params.salesmanID = "'" + row.salesmanID + "'"
        } else if (this.activeName == 'deliverUser') {
          params.deliverUserID = "'" + row.deliverUserID + "'"
        }
        const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/salOrderReport/selectOrderDetailList.html', params)
        if (res.code == '0') {
          this.tableData[row.index].children = res.data
          this.tableData[row.index]['isLoad'] = true
        }
      }
      this.$refs.table.toggleRowExpansion(row)
    },
    async tableDBClick(row) {
      let { billNo, billType } = row
      this.detailDrawer = true
      this.drawerTableIsLoading = true
      this.detailDrawerActiveRow = row
      let url = ''
      if (billType == 'XST') {
        url = '/Account/salOrderReturn/selectSalOrderReturnDetailVueList.html'
      } else {
        url = '/Account/salOrder/selectSalOrderDetailVueList.html'
      }
      const option = {
        method: 'post',
        url,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': '*/*'
        }, // 解决后端返回参数乱码问题
        data: this.Qs.stringify({ billNo: billNo })
      }
      const { data: res } = await this.$http(option)
      this.drawerTableIsLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      const { headInfo, itemList: tableData } = JSON.parse(res.result.data)
      this.detailDrawerHeader = headInfo
      this.detailList = tableData
      this.$nextTick(() => {
        let height = this.$refs.drawerTableCard.$el.offsetHeight
        this.$refs.drawerTableList.style.height = `calc(100% - ${height}px - 4px)`
      })
    },
    sortChange({ prop, order }) {
      if (order == 'ascending') {
        order = 'ASC'
      } else if (order == 'descending') {
        order = 'DESC'
      }
      this.pagination.sortField = prop
      this.pagination.sortBy = order
      this.pagination.page = 1
      this.getTable()
    },
    onReset() {
      this.$refs['queryFormRef'].resetFields()
      this.pagination.sortField = ''
      this.pagination.sortBy = ''
      this.onSubmit()
    },
    handleClick() {
      this.$nextTick(() => {
        this.pagination.sortField = ''
        this.pagination.sortBy = ''
        if (this.activeName != 'completionRate') {
          this.onSubmit()
        } else {
          this.tableData = []
        }
      })
    },
    handleSizeChange(newSize) {
      this.pagination.size = newSize
      this.getTable()
    },
    handleCurrentChange(newPage) {
      this.pagination.page = newPage
      this.getTable()
    },
    detailExport() {
      if (!this.detailList.length) return this.$message.error('请至少选择一个单据')
      let { billNo, billType } = this.detailDrawerActiveRow
      let element = this.$refs.drawerTable
      let tempArr = element.$children.map(item => ({
        label: item.label,
        prop: item.prop
      })).filter(item => item.prop)
      let url = '/Account/salOrder/exportSalOrderDetailListForVue.html'
      if (billType == 'XST') {
        url = '/Account/salOrderReturn/exportSalOrderReturnDetailListForVue.html'
      }
      exportExcelCommonForVue({ billNo }, tempArr, url)
    },
    tableExport() {
      let element = this.$refs.table.$refs.table
      let tempArr = element.$children.map(item => ({
        label: item.label,
        prop: item.prop
      })).filter(item => item.prop)
      let params = { ...this.queryFormat, ...this.pagination }
      if (this.activeName == 'commodity') {
        params.billSearchType = 2
      } else if (this.activeName == 'customer') {
        params.billSearchType = 0
      } else if (this.activeName == 'business') {
        params.billSearchType = 1
      } else if (this.activeName == 'deliverUser') {
        params.billSearchType = 3
      }
      exportExcelCommonForVue(params, tempArr, '/erpnew/account/c/reada46ceb/salOrderReport/salOrderExport.html')
    }
  }
}
</script>

<style scoped lang="less">
.order {
  height: 100%;
}

::v-deep .select_multiple {
  .el-select__tags {
    max-height: 80px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

::v-deep .tabs {
  border-bottom: none;

  .el-tabs__item {
    height: 34px;
    line-height: 34px;
  }

  .el-tabs__content {
    padding: 0;
  }
}

.main {
  border-top: none;
  height: calc(100% - 35px);

  .el-container {
    height: 100%;
    padding: 10px;

    .el-aside {
      ::v-deep .aside-card {
        height: calc(100% - 2px);

        .el-card__header {
          padding: 8px 20px;
          height: 33px;
          background-color: #F5F7FA;
          color: #409EFF;
        }

        .el-card__body {
          padding: 6px;
          height: calc(100% - 33px);
          box-sizing: border-box;

          .el-form {
            height: calc(100% - 70px);

            .el-scrollbar {
              height: 100%;
            }

            .el-form-item {
              margin: 18px 0 0;
              position: relative;

              .el-form-item__label {
                position: absolute;
                z-index: 2;
                top: -12px;
                margin-left: 10px;
                padding: 0 6px;
                line-height: normal;
                background-color: #fff;
              }
            }
          }
        }
      }

      .is-collapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
      }
    }

    .el-main {
      padding: 0 0 0 6px;

      ::v-deep .el-card__body {
        padding: 6px 12px;

        .el-form-item {
          margin: 0;
        }
      }

      .table {
        height: calc(100% - 84px);
        margin-bottom: 8px;
      }
    }
  }
}

.detail_drawer {
  .el-drawer__body {
    display: flex;
    flex-direction: column;

    .detail_drawer_card {
      border: none;
      flex-shrink: 0;

      .el-card__body {
        padding: 10px 15px;
      }

      .el-col {
        margin-bottom: 10px;
        display: flex;
        align-items: center;

        label {
          display: inline-block;
          width: 60px;
          text-align: right;
          margin-right: 6px;
        }
      }
    }
  }
}</style>